// extracted by mini-css-extract-plugin
export default {"gameProvider":"GameProvider__gameProvider--K4I"};